module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_flutter_blink_high_pitched_003_44032.84197bb5.mp3";